<div>
  @for (repeat of [].constructor(count); track repeat) {
    <div>
      <ngx-skeleton-loader [theme]="loaderTheme"></ngx-skeleton-loader>
    </div>
  }
</div>
